<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<!-- <el-form-item label="店铺名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item> -->
					<el-form-item label="核销码" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.hxCode" placeholder="请输入核销编号">
						</el-input>
					</el-form-item>

					<el-form-item label="订单编号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderCode" placeholder="请输入订单编号">
						</el-input>
					</el-form-item>
					
					<el-form-item label="核销人" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.hxUsername" placeholder="请输入核销人名称">
						</el-input>
					</el-form-item>
					<el-form-item label="订单状态:" label-width="80px">
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option key="0" label="待付款" :value="0">待付款</el-option>
							<el-option key="1" label="待核销" :value="1">待核销</el-option>
						<!-- 	<el-option key="2" label="待收货" :value="2">待</el-option> -->
							<el-option key="3" label="已完成" :value="3">已完成</el-option>
							<el-option key="4" label="退款申请" :value="4">退款申请</el-option>
							<el-option key="5" label="已退款" :value="5">已退款</el-option>
							<el-option key="6" label="部分退款" :value="6">部分退款</el-option>
							<el-option key="7" label="已失效" :value="7">已失效</el-option>
							<el-option key="8" label="驳回" :value="8">驳回</el-option>
						</el-select>
					</el-form-item>
					
				<!-- 	<el-form-item label="所属区域:" label-width="80px">
						<el-select clearable filterable v-model="searchInfo.provinceId" placeholder="请选择省" @change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.cityId" placeholder="请选择市" @change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.areaId" placeholder="请选择区" @change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item  label="市:" label-width="150px">
                    
                </el-form-item>
                <el-form-item  label="区:" label-width="150px">
                    
                </el-form-item> -->

					<el-form-item label="创建时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
							 start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">导出</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<!-- <el-table-column prop="id" label="订单ID"  align="center"  :show-overflow-tooltip="true">
            </el-table-column> -->
			<el-table-column prop="username" label="用户名" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="hxCode" label="核销码" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderCode" label="订单编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderTotalPrice" label="订单总价(￥)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="settlementPrice" label="结算价格(￥)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="订单状态" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#E6A23C;">待付款</span>
					<span v-if="scope.row.status==1" style="color:#9042bd;">待核销</span>
					<!-- <span v-if="scope.row.status==2">待收货</span> -->
					<span v-if="scope.row.status==3" style="color:#67C23A;">已完成</span>
					<span v-if="scope.row.status==4" style="color:#41cad7;">退款申请</span>
					<span v-if="scope.row.status==5" style="color:#41cad7;">已退款</span>
					<span v-if="scope.row.status==6" style="color:#41cad7;">部分退款</span>
					<span v-if="scope.row.status==7" style="color:#909399;">已失效</span>
					<span v-if="scope.row.status==8" style="color:#F56C6C;">驳回</span>
					
				</template>
			</el-table-column>
			
			
			<el-table-column prop="rewardIntegralNumber" label="送流量池数量" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="payTime" label="支付时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="hxUsername" label="核销人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="hxDatetime" label="核销时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="" label="详情" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row)">查看</el-button>
				<el-button v-if="scope.row.status==1&&isTk"  size="small" type="text" @click="disposeSH(scope.row, scope.row.status)">退款
				</el-button>
				</template>
			</el-table-column>

		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum" @current-change="pageChange"
		 layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<div style="margin:10px 0 ;">商品详情</div>
				<div class="orderList">

					<div class="orderxq" v-for="(item,index) in orderInfo.ssStoreOrderGoodsDtos" :key="index">
						<div>
							<img :src="item.images.split(',')[0]" alt="" style="width:100px;height:100px;">
						</div>
						<div style="margin-left:20px;">
							<p>{{item.goodsName}}</p>
							<p>购买数量：{{item.num}}</p>
							<p>单价：{{item.price}}</p>
						</div>

					</div>

				</div>
				
				<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
					<el-form-item label="订单号">
						<span>{{orderInfo.orderCode}}</span>
					</el-form-item>
					
					<el-form-item label="支付类型">
				

						<span v-if="orderInfo.payType=='wx'">微信支付</span>
						<span v-if="orderInfo.payType=='alipay'">支付宝支付</span>
						<span v-if="orderInfo.payType=='integral'">积分抵扣-{{orderInfo.integralName}}</span>
						<span v-if="orderInfo.payType=='wxplural'">微信积分混合支付</span>
						<span v-if="orderInfo.payType=='aliplural'">支付宝混合支付</span>
					</el-form-item>

					
				
					<el-form-item label="订单状态">
						<span v-if="orderInfo.status==1">待核销</span>
						<!-- <span v-if="orderInfo.status==2">待收货</span> -->
						<span v-if="orderInfo.status==3">已完成</span>
						<span v-if="orderInfo.status==5">已退款</span>
						
					</el-form-item>
					<el-form-item label="退款方式" v-if="orderInfo.status==5">
						<span v-if="orderInfo.returnType==2">退Cash</span>
						<span v-if="orderInfo.returnType==1">原路退回</span>
					</el-form-item>
					<el-form-item label="退款原因" v-if="orderInfo.status==5">
						<span>{{orderInfo.returnInstructions}}</span>
						
					</el-form-item>
					<el-form-item label="退款操作人" v-if="orderInfo.status==5">
						{{orderInfo.refundOpUser}}
					</el-form-item>
					<el-form-item label="退款操作时间" v-if="orderInfo.status==5">
					{{orderInfo.refundTime}}
						
					</el-form-item>
					<el-form-item label="订单总价">
						<span>￥{{orderInfo.orderTotalPrice}}</span>
					</el-form-item>
					<el-form-item label="用户">
						<span>{{orderInfo.username}}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{orderInfo.phone}}</span>
					</el-form-item>
					
					<el-form-item label="支付时间">
						<span>{{orderInfo.payTime}}</span>
					</el-form-item>
					<el-form-item label="核销时间" v-if="orderInfo.hxDatetime">
						<span>{{orderInfo.hxDatetime}}</span>
					</el-form-item>
					<el-form-item label="完成时间" v-if="orderInfo.completeTime">
						<span>{{orderInfo.completeTime}}</span>
					</el-form-item>
				
					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog style="float:rigin" title="退款" :visible.sync="tkDialogVisibles" width="50%"
			:close-on-click-modal="false">
			
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item v-if="tkinfo.goodsList" label="商品名称:" label-width="120px">
										
						{{tkinfo.goodsList[0].goodsName}}
					</el-form-item>
					<el-form-item v-if="tkinfo.goodsList" label="数量:" label-width="120px">
										
						{{tkinfo.goodsList[0].num}}件
					</el-form-item>
					<el-form-item v-if="tkinfo.goodsList" label="数量:" label-width="120px">
							<img :src="tkinfo.goodsList[0].images.split(',')[0]" style="width: 80px;height: 80px;" alt="" />			
					</el-form-item>
					<el-form-item label="订单号:" label-width="120px">
										
						{{tkinfo.orderCode}}
					</el-form-item>
					<el-form-item label="下单人:" label-width="120px">
							{{ tkinfo.userId }}
							<span v-if="tkinfo.username">~{{ tkinfo.username}}</span>
							<span v-if="tkinfo.userPhone">~{{tkinfo.userPhone}}</span>			
						
					</el-form-item>
					<el-form-item label="付款方式:" label-width="120px">
						<el-span>					{{tkinfo.payType=='aliplural'?'支付宝混合支付':tkinfo.payType=='wxplural'?'微信混合支付':tkinfo.payType=='wx'?'微信支付':tkinfo.payType=='alipay'?'支付宝支付':'积分支付'}}</el-span>
						（{{tkinfo.integralName}}）
					</el-form-item>
					<el-form-item label="退款金额:" label-width="120px">
						<el-span>￥{{tkinfo.orderTotalPrice}}</el-span>
					</el-form-item>
					<el-form-item label="退款方式:" label-width="120px" >
						<el-radio-group v-model="returnType" 
						style="margin-top:10px;">
							<el-radio :label="2">退Cash</el-radio>
							<el-radio :label="1">原路退回</el-radio>
						</el-radio-group>
					</el-form-item>
					
				
					
					<el-form-item label="原因:" label-width="120px" >
						<el-input style="width: 100%;" v-model="reasons" placeholder="请输入原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="refunds" :loading="tkDialog" >确 认</el-button>
				<el-button  @click="tkDialogVisibles = false">取 消</el-button>
			</div>
		</el-dialog>
		
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				reasons:'',
				orderList: [],
				returnType:2,
				dialogVisible: false,
				tkDialogVisibles:false,
				loading:false,
				editDialogVisible: false,
				searchInfo: {
					status: ''
				},
				orderInfo: {},
				tkDialog:false,
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				tkinfo:{},
				provinceList: {},
				isTk:'',
				cityList: {},
				districtList: {},
				sysExpressList: [],
				storeOrder: {},
				shipments_orderCode:'',
				shipments_name:'',
				shipments_address:'',
				expressType:'',
				ExpDialog: false , //查看物流弹窗
				wudetail:[{}], //查看物流数据
			};
		},
		methods: {
			disposeSH(it, num){ //充值结果操作弹窗打开
			console.log(it);
				this.tkinfo=it
				this.tkDialogVisibles = true;
			},
			refunds(){
				let data={
					returnType:this.returnType,
					returnInstructions:this.reasons,
					id:this.tkinfo.id
				}
				this.$api.refundss(data).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.tkDialogVisibles = false;
						this.reasons=''
						this.storeOrderList();
					} else {
						this.$message.error(res.message);
					}
					this.tkDialog = false;
				})
			},
			downloadFile() {
				let data = {
					...this.searchInfo
				};
				// console.log(data);
				this.$api.sstoExcelstoreOrder(data).then((res) => {
					console.log(res);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				console.log(res);
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "门店订单" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// supplierId(有值就是供应商)
						// this.userStoreID = res.data.storeId; // storeId：0(平台)   
						this.$api.findkey('SYS_TUIKUAN').then(ress=>{
							this.isTk=ress.data.settingValue.split(',').find(it=>it==res.data.id)
						})
					}
				})
				
			},
			lookexp(id){ //查看物流
				this.$api.lookExpress(id).then(res=>{
					if(res.state=='success'){
						this.ExpDialog=true
						this.wudetail=JSON.parse(res.data.detail).reverse()
					}else{
						this.$message.error(res.message);
					}
				})
			},
			shipmentsClick(item){ //表格点击发货
				// console.log('点击的表格数据---',item)
				this.storeOrder = {};	
				this.storeOrder.id = item.id;
				this.storeOrder.status = 2;
				this.storeOrder.storeId = item.storeId;
				this.shipments_orderCode = item.orderCode;
				this.shipments_address = item.address;
				this.expressType = '';
				this.$api.findOrderInfo(item.id).then((res) => { //查询订单详情
					if (res.state == 'success') {
						this.shipments_name = res.data.name+"-"+res.data.phone;
						this.editDialogVisible = true;
					}
				})
				
			},
			shipments() {
				this.loading=true
				let data={}
				if(this.expressType==2){ //自提
					data = {
						sendRemark: this.storeOrder.sendRemark,
						expressId: 1,
						storeId: this.storeOrder.storeId,
						status: 3,
						id: this.storeOrder.id
					}
				}else{ //快递
					data = {
						expressCode: this.storeOrder.expressCode,
						sendRemark: this.storeOrder.sendRemark,
						// sendOpUser: this.sendOpUser,//发货人
						expressId: this.storeOrder.expressId,
						storeId: this.storeOrder.storeId,
						status: 2,
						id: this.storeOrder.id
					}
				}
				// this.storeOrder
				this.$api.orderShipments(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
						this.loading=false
						this.storeOrderList();
					} else {
						this.$message.error(res.message);
						this.loading=false
					}
				})
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()

			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					
					username: this.searchInfo.username,
					// storeName: this.searchInfo.storeName,
					orderCode: this.searchInfo.orderCode,
					status: this.searchInfo.status,
					hxCode: this.searchInfo.hxCode,
					hxUsername: this.searchInfo.hxUsername,
					
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.findSsorder(data).then((res => { //原门店订单
				// this.$api.storeOrderList(data).then((res => { //商城订单
					// console.log(res)
					if (res.state == 'success') {
						this.orderList = res.data.list
						this.sliderlist = res.data
						// console.log(this.sliderlist)

					}
				}))
			},
			getAreasList(){
				//查询省
				this.$api.getAreasFive(0).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.provinceList = res.data
						//  console.log(this.provinceList)
					}
				})
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				// this.setTLevelData.areaId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},

			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(e) {
				
				this.orderInfo = e
				// console.log(this.orderInfo)
				this.dialogVisible = true
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
		},

		created() {
			this.storeOrderList();
			this.getAreasList();
			this.logInUserInfo()
		},
		mounted() {
			this.$api.sysExpressList({}).then((res) => {
				if (res.state == 'success') {
					this.sysExpressList = res.data.list
				}
			})
		}
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}
</style>
